module.exports = __webpack_public_path__ + "img/MGH-Nihonbashi-6-2440x1172.6e994523.jpg";